import Group from '@components/Group';
import Tag from '@components/Tag';
import Text from '@components/Text';
import Title from '@components/Title';
import { Work } from '@ts/index';
import React from 'react';
import { StyledImage, StyledWorkContent, StyledWorkImage, StyledWorkItem, StyledWorkSection, StyledWorkYear } from './styled';

import youtube from '@images/youtube.png';
import blog from '@images/blog.png';
import lifetime from '@images/lifetime.png';
import devLifetime from '@images/dev.lifetime.png';
import api from '@images/api-query.png';
import beauty from '@images/beauty-point.png';
import gmail from '@images/gmail.png';
import dropbox from '@images/dropbox.png';
import Link from '@components/Link';

interface IWorkItemProps extends Work {
  children?: React.ReactNode;
}

const images = {
  youtube,
  blog,
  api,
  lifetime,
  'dev.lifetime': devLifetime,
  'beauty-point': beauty,
  gmail,
  dropbox
}

export type ImageName = keyof typeof images;

const WorkItem:React.FC<IWorkItemProps> = ({
  image,
  year,
  title,
  desc,
  tags,
  links
}) => {
  return (
    <StyledWorkItem>
      <StyledWorkImage>
        <StyledImage
          fill
          src={images[image]}
          priority
          alt={title}
          sizes="(max-width: 768px) 100vw, 586px"
        />
      </StyledWorkImage>
      
      <StyledWorkContent>
        <Title size={26}>
          {title}
        </Title>
        <StyledWorkYear>
          {year}
        </StyledWorkYear>
        {
          !!desc && (
            <Text>
              {desc}
            </Text>
          )
        }

        <StyledWorkSection>
          <Title size={18}>Project stack</Title>
          <Group gap={6} align='center'>
            {tags.map(t => <Tag key={t}>{t}</Tag>)}
          </Group>
        </StyledWorkSection>

        {!!links && (
          <StyledWorkSection>
            <Title size={18}>Links</Title>
            <Group gap={12} align='center'>
              {!!links.demo && (
                <Link
                  target={'_blank'}
                  href={links.demo}
                  rel='noreferrer'
                  id={`${title}-demo`}
                >
                  Live Demo
                </Link>
              )}
              {!!links.repo && (
                <Link
                  target={'_blank'}
                  href={links.repo}
                  rel='noreferrer'
                  id={`${title}-github`}
                >
                  Github Repository
                </Link>
              )}
            </Group>
          </StyledWorkSection>
        )}
      </StyledWorkContent>
    </StyledWorkItem>
  );
}

export default WorkItem;
